import React, { useState } from 'react';
import { Table, Button, Tooltip, Popconfirm, Select, Row } from 'antd';
import { DeleteOutlined, SwapOutlined } from '@ant-design/icons';
import DetailsTable from './detailsTable';


export default function ViewTables({
  loading,
  t,
  approvedBy,
  completeEstimate,
  completeEstimateByArea,
  allSubVendors,
  tagRender,
  setCompleteEstimate,
  handleSaveEstimateSubvendors,
  removeItems,
  handleEdit,
  handleAddSubVendors,
}) {
  const [viewByService, setViewByService] = useState(false); // false = view by area, true = view by service

  const tableColumns = [
    {
      title: (
        <Tooltip title="Change View">
          <Button type="link" ghost onClick={() => setViewByService(false)}>
            <span style={{ marginLeft: '5px', fontWeight: 'bold', color: '#0f4c81' }}>
              {t('screens:estimate.laborGroup')}
            </span>
            <SwapOutlined />
          </Button>
        </Tooltip>
      ),
      dataIndex: 'name',
      key: 'name',
      ellipsis: {
        showTitle: false,
      },
      align: 'center',
      width: '20%',
    },
    {
      title: t('screens:estimate.subVendors'),
      key: 'subVendors',
      ellipsis: {
        showTitle: false,
      },
      align: 'center',
      width: '80%',
      render: record => (
        <Select
          disabled={approvedBy !== null}
          mode="multiple"
          showArrow
          tagRender={tagRender}
          style={{ width: '100%' }}
          value={record?.subVendors?.map(subVendor => subVendor?.id) || []}
          options={allSubVendors
            .filter(subVendor => subVendor.laborTypes.find(laborType => laborType.id === record.laborTypeId))
            .map(subVendor => ({
              value: subVendor.id,
              label: `${subVendor.id} - ${subVendor.companyName}`,
            }))}
          onChange={newValue => {
            const newCompleteEstimate = completeEstimate.map(estimate => {
              if (estimate.id === record.id) {
                estimate.subVendors = newValue.map(value => {
                  const subVendor = allSubVendors.find(subVendor => subVendor.id === value);
                  return subVendor;
                });
              }
              return estimate;
            });
            setCompleteEstimate(newCompleteEstimate);
            handleSaveEstimateSubvendors();
          }}
          placeholder="Select Subcontractors..."
          maxTagCount="responsive"
        />
      ),
    },
    {
      title: t('screens:estimate.data.actions'),
      key: 'actions',
      align: 'center',
      width: '90px',
      render: record => (
        <Popconfirm
          icon={false}
          title={t('messages:confirmDelete')}
          onConfirm={() => removeItems(item => item.laborType.id === record.id)}
          okText={t('messages:yes')}
          cancelText={t('messages:no')}
        >
          <Tooltip title={t('screens:estimate.deleteGroup')} placement="bottom">
            <Button type="link" icon={<DeleteOutlined />} />
          </Tooltip>
        </Popconfirm>
      ),
    },
  ].filter(column => {
    if (approvedBy !== null && column.key === 'actions') {
      return false;
    }
    return true;
  });

  const tableColumnsByArea = [
    {
      title: (
        <Tooltip title="Change View">
          <Button type="link" onClick={() => setViewByService(true)}>
            <span style={{ marginLeft: '5px', fontWeight: 'bold', color: '#0f4c81' }}>
              {t('screens:estimate.area')}
            </span>
            <SwapOutlined />
          </Button>
        </Tooltip>
      ),
      dataIndex: 'name',
      key: 'name',
      ellipsis: {
        showTitle: false,
      },
      align: 'center',
      width: '20%',
    },
    {
      key: 'subVendors',
      ellipsis: {
        showTitle: false,
      },
      align: 'center',
      width: '80%',
      render: record => <></>,
    },
    {
      title: t('screens:estimate.data.actions'),
      key: 'actions',
      align: 'center',
      width: '90px',
      render: record => (
        <Popconfirm
          icon={false}
          title={t('messages:confirmDelete')}
          onConfirm={() => removeItems(item => item.area.id === record.id)}
          okText={t('messages:yes')}
          cancelText={t('messages:no')}
        >
          <Tooltip title={t('screens:estimate.deleteGroup')} placement="bottom">
            <Button type="link" icon={<DeleteOutlined />} />
          </Tooltip>
        </Popconfirm>
      ),
    },
  ].filter(column => {
    if (approvedBy !== null && column.key === 'actions') {
      return false;
    }
    return true;
  });

  return viewByService ? (
    <Row>
      <Table
        bordered
        rowKey="id"
        pagination={false}
        loading={loading}
        columns={tableColumns}
        dataSource={completeEstimate}
        expandable={{
          expandedRowRender: record => (
            <DetailsTable
              items={record.items}
              loading={loading}
              t={t}
              viewByService={viewByService}
              approvedBy={approvedBy}
              completeEstimate={completeEstimate}
              handleEdit={handleEdit}
              removeItems={removeItems}
              handleAddSubVendors={handleAddSubVendors}
            />
          ),
          rowExpandable: record => record.name !== 'Not Expandable',
        }}
      />
    </Row>
  ) : (
    <Row>
      <Table
        bordered
        rowKey="id"
        pagination={false}
        loading={loading}
        columns={tableColumnsByArea}
        dataSource={completeEstimateByArea}
        expandable={{
          expandedRowRender: record => (
            <DetailsTable
              items={record.items}
              loading={loading}
              t={t}
              viewByService={viewByService}
              approvedBy={approvedBy}
              completeEstimate={completeEstimate}
              handleEdit={handleEdit}
              removeItems={removeItems}
              handleAddSubVendors={handleAddSubVendors}
            />
          ),
          rowExpandable: record => record.name !== 'Not Expandable',
        }}
      />
    </Row>
  );
}
